import {read} from "@/api/rest";

const educationProgram = {
  index: async () => await read('/education-program'),
};

export default educationProgram;